import { IProduct, IPrice, IInventory, Category } from "@/entities";
import { Group } from "@/entities/group/group";
import { Metadata } from "@/entities/metadata/metadata";
import { PreOrder } from "@/entities/preorder/preorder";
import { CatalogAPIRepository } from "@/repositories/catalog/api";
import { GroupAPIRepository } from "@/repositories/group/api";
import { InventoryAPIRepository } from "@/repositories/inventory";
import { PriceAPIRepository } from "@/repositories/price";
import { ProductAPIRepository } from "@/repositories/product";
import { ICatalogService } from "./catalog.types";
import { mini } from "@/settings/branchs";
import { OnlineStore } from "@/entities/onlineStore/onlineStore";


export class Catalog implements ICatalogService {
    priceRepository: PriceAPIRepository;
    productRepository: ProductAPIRepository;
    inventoryRepository: InventoryAPIRepository;
    groupRepository: GroupAPIRepository;
    catalogRepository: CatalogAPIRepository;
    constructor() {
        this.priceRepository = new PriceAPIRepository()
        this.productRepository = new ProductAPIRepository()
        this.inventoryRepository = new InventoryAPIRepository()
        this.groupRepository = new GroupAPIRepository()
        this.catalogRepository = new CatalogAPIRepository()
        this.rootCategory = new Category({ groupName: "root", productList: [] });
        this.recommendCategory = new Category({ groupName: "root", productList: [] });
        this.additionalCategory = new Group({
            groupId: 0,
            groupName: "root",
            enabled: true,
            metadata: new Metadata({}),
            subGroupList: [],
            parentGroupList: [],
            productList: []
        })
        this.recommendGroup = new Group({
            groupId: 0,
            groupName: "recommend",
            enabled: true,
            metadata: new Metadata({}),
            subGroupList: [],
            parentGroupList: [],
            productList: []
        })
        this.text = "tester"
    }

    text: string;
    rootCategory?: Category;
    recommendCategory?: Category;
    additionalCategory?: Group;
    recommendGroup?: Group;
    productMap?: Map<number, IProduct>;
    priceMap?: Map<number, Map<number, IPrice>>;
    inventoryMap?: Map<number, Map<number, IInventory>>;
    loading?: boolean;
    // allInventory?: Map<number, Map<number, IInventory>>[];

    async initialAsync(branchCode: number): Promise<void> {
        try {
            this.loading = true
            await Promise.all([
                this.getProduct(),
                this.getPrice(branchCode),
                this.getInventory(branchCode),
                this.getCatalog()
            ])
            const branchList = mini();
            await Promise.all(branchList.map(async (b) => {
                if (b.code !== "1000") {
                    const result = await this.inventoryRepository.getInventory(parseInt(b.code));
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.inventoryMap = new Map([...this.inventoryMap!, ...result])
                }
            }));
            // console.log(this.productMap)
            // console.log(this.priceMap)
            console.log("inventoryMap", this.inventoryMap);
            // this.inspectAdditionalCategoryGroup();
            // this.groupProduct();
            // this.mergeCategory();
            await this.computeMetadata();
            // await Promise.all([
            //     this.getPrice(branchCode),
            //     this.getInventory(branchCode),
            // ]);
            this.mergePrice(branchCode);
            this.mergeInventory(branchCode);
            console.log("Catelog initial done.");
            // this.refreshProductMap();
            // this.refreshRootCategory();
            // console.log(`initialAsync catalog executed in ${stopwatch.elapsed}`);
        } catch (e) {
            console.log(`Catalog: initialAsync: ${e}`);
        } finally {
            this.loading = false;
            // update();
        }
    }
    // inspectAdditionalCategoryGroup(): void {
    //     console.log(
    //         "group root: ${this.additionalCategory.value.groupId} ${this.additionalCategory.value.groupName}");
    //     this.additionalCategory?.subGroup?.forEach((group) => {
    //         console.log(
    //             "   |- ${group.groupId} ${group.groupName} has ${group.productList.length} items");
    //         group.subGroup?.forEach((group) => {
    //             console.log(
    //                 "      |- ${group.groupId} ${group.groupName} has ${group.productList.length} items");
    //             group.subGroup?.forEach((group) => {
    //                 console.log(
    //                     "         |- ${group.groupId} ${group.groupName} has ${group.productList.length} items");
    //             });
    //         });
    //     });
    // }

    refreshRootCategory(): void {
        // this.rootCategory.refresh();
    }
    refreshProductMap(): void {
        // this.productMap.refresh();
    }

    async getProduct(): Promise<void> {
        // console.log('getProduct', this.productRepository.getAllProduct())
        this.productMap = await this.productRepository.getAllProduct()
    }
    async getPrice(branchCode: number): Promise<void> {
        this.priceMap = await this.priceRepository.getPrice(branchCode)
    }
    async getInventory(branchCode: number): Promise<void> {
        this.inventoryMap = await this.inventoryRepository.getInventory(branchCode)
    }

    async getCatalog(): Promise<void> {
        this.rootCategory = await this.catalogRepository.getCatalog()
    }

    async computeMetadata(): Promise<void> {
        for (const [_, cat] of (this.rootCategory?.subCategory as Map<string, Category>)) {
            // console.log({cat});
            // this.rootCategory?.subCategory?.forEach((cat: Category) => {
            if (cat.groupName == "Beer Wine & Spirits") {
                for (const product of cat.productList) {
                    const p = this.productMap?.get(product)
                    if (p) {
                        p.storeOnly = true;
                    }
                }
            }

            for (const [_, subgroup] of (cat.subCategory as Map<string, Category>)) {
                // cat.subCategory?.forEach((subgroup: Category) => {
                //
                // console.log({subgroup});
                subgroup.subCategory?.forEach((subsubgroup: Category) => {
                    // console.log({subsubgroup});
                    const subsubgroupMetadata = subsubgroup.metadata
                    if (subsubgroupMetadata) {
                        let preorder: PreOrder
                        if (subsubgroupMetadata.preType) {
                            // console.log("create preorder");
                            preorder = new PreOrder({
                                startDate: subsubgroupMetadata.startDate,
                                endDate: subsubgroupMetadata.endDate,
                                preType: subsubgroupMetadata.preType,
                                preQtyPerDay: subsubgroupMetadata.preQtyPerDay,
                                preRelativeDay: subsubgroupMetadata.preRelativeDay,
                                deliveryDate: subsubgroupMetadata.deliveryDate,
                            });
                        }

                        subsubgroup.productList.forEach((product: number) => {
                            if (this.productMap?.get(product)) {
                                // if (product["cprcode"] != null) {
                                if (subsubgroupMetadata.badgeLeft != null) {
                                    const p = this.productMap.get(product)
                                    if (p) {
                                        p.badgeLeft = subsubgroupMetadata.badgeLeft;
                                    }
                                }

                                if (preorder != null) {
                                    const p = this.productMap.get(product)
                                    if (p) {
                                        p.preOrder = preorder
                                    }
                                }
                            }
                        });
                    }
                });

                const subgroupMetadata = subgroup.metadata
                if (subgroupMetadata) {
                    if (subgroupMetadata.two4 == true) {
                        // fetch two4
                        const twoFor = await this.groupRepository.getTwoFor(`${subgroup.groupId}`);
                        subgroup.productList.forEach((product) => {
                            const p = this.productMap?.get(product)
                            if (p) {
                                p.twofor = twoFor["two4Dict"][product.toString()];
                            }
                        });
                    }

                    subgroup.productList.forEach((product) => {
                        const p = this.productMap?.get(product)
                        if (p) {
                            if (subgroupMetadata.badgeLeft != null) {
                                p.badgeLeft = subgroupMetadata.badgeLeft;
                            }
                        }
                    })
                }
                //
            }
        }

    }//

    mergePrice(branchCode: number): void {
        // this.productMap?.forEach((product, cprcode) => {
        //     if (this.priceMap?.has(branchCode)) {
        //         if (this.priceMap?.get(branchCode)?.get(cprcode)) {
        //             if (this.productMap?.get(cprcode)?.isAvailableAt(branchCode)) {
        //                 this.productMap?.get(cprcode)?.availableStore?.get(branchCode)?.
        //                     setPrice(this.priceMap?.get(branchCode)?.get(cprcode) as IPrice)
        //             }
        //         }
        //     }
        // })
        this.productMap?.forEach((product, cprcode) => {
            if (this.priceMap?.get(branchCode)?.get(product.cprcode)) {
                if (this.productMap?.get(cprcode)?.isAvailableAt(branchCode)) {
                    const pr = this.priceMap.get(branchCode)?.get(product.cprcode)
                    // if(cprcode === 58939){
                    //     console.log('mergePrice', product)
                    // }
                    if (pr) {
                        this.productMap.get(cprcode)?.availableStore.get(branchCode)?.
                            setPrice(pr)
                    }
                    return;
                }
                else {
                    // this.addStore(new OnlineStore({ brcode: parseInt(brcode), visibility: visi.visibility }))
                    this.productMap?.get(cprcode)?.addStore(new OnlineStore({ brcode: branchCode, visibility: true }))
                    const pr = this.priceMap.get(branchCode)?.get(product.cprcode)
                    if (pr) {
                        this.productMap?.get(cprcode)?.availableStore.get(branchCode)?.
                            setPrice(pr)
                    }
                }
            }
        })
    }

    mergeInventory(branchCode: number): void {
        // this.productMap?.forEach((product, cprcode) => {
        //     if (this.inventoryMap?.has(branchCode)) {
        //         if (this.inventoryMap?.get(branchCode)?.get(cprcode)) {
        //             if (this.productMap?.get(cprcode)?.isAvailableAt(branchCode)) {
        //                 this.productMap?.get(cprcode)?.availableStore?.get(branchCode)?.
        //                     setInventory(this.inventoryMap?.get(branchCode)?.get(cprcode) as IInventory)
        //             }
        //         }
        //     }
        // })

        // this.productMap?.forEach((product, cprcode) => {
        //     if (this.inventoryMap?.get(branchCode)?.get(product.iprcode)) {
        //         if (this.productMap?.get(cprcode)?.isAvailableAt(branchCode)) {
        //             const i = this.inventoryMap.get(branchCode)?.get(product.iprcode)
        //             if (i) {
        //                 this.productMap.get(cprcode)?.availableStore.get(branchCode)?.
        //                     setInventory(i)
        //             }
        //         }
        //     }
        // })

        const branchList = mini();
        this.productMap?.forEach((product, cprcode) => {
            if (this.inventoryMap?.get(branchCode)?.get(product.iprcode)) {
                branchList.forEach((b) => {
                    if (this.productMap?.get(cprcode)?.isAvailableAt(parseInt(b.code))) {
                        const i = this.inventoryMap?.get(parseInt(b.code))?.get(product.iprcode)
                        if (i) {
                            this.productMap.get(cprcode)?.availableStore.get(parseInt(b.code))?.
                                setInventory(i)
                        }
                    }
                })
            }
        })
    }

    // groupProduct(): void {
    //     this.productMap?.forEach((value: IProduct, key: number) => {
    //         const l1: string = value.onlineCategoryL1En;
    //         const l2: string = value.onlineCategoryL2En;
    //         const l3: string = value.onlineCategoryL3En;
    //         if (this.rootCategory?.subCategory?.get(l1) === null) {
    //             // create category
    //             const l1Category: Category = new Category({ groupName: l1, productList: [] });
    //             // put to category tree
    //             // this.rootCategory.value.subCategory[l1] = l1Category;
    //             this.rootCategory?.subCategory?.set(l1, l1Category)
    //         }
    //         if (this.rootCategory?.subCategory?.get(l1) !== null) {
    //             // add product to the list
    //             this.rootCategory?.subCategory?.get(l1)?.productList.push(value.cprcode);

    //             if (this.rootCategory?.subCategory?.get(l1)?.subCategory?.get(l2) === null) {
    //                 // create category
    //                 const l2Category: Category = new Category({ groupName: l2, productList: [] });

    //                 // put to category tree
    //                 this.rootCategory?.subCategory?.get(l1)?.subCategory?.set(l2, l2Category)
    //             }

    //             if (this.rootCategory?.subCategory?.get(l1)?.subCategory?.get(l2) !== null) {
    //                 // add product to the list
    //                 this.rootCategory?.subCategory?.get(l1)?.subCategory?.get(l2)?.productList.push(value.cprcode);

    //                 if (this.rootCategory?.subCategory?.get(l1)?.subCategory?.get(l2)?.subCategory?.get(l3) ===
    //                     null) {
    //                     // create category
    //                     const l3Category: Category = new Category({ groupName: l3, productList: [] });
    //                     // put to category tree
    //                     this.rootCategory?.subCategory?.get(l1)?.subCategory?.get(l2)?.subCategory?.set(l3, l3Category);
    //                 }

    //                 if (this.rootCategory?.subCategory?.get(l1)?.subCategory?.get(l2)?.subCategory?.get(l3) !== null) {
    //                     // add product to the list
    //                     this.rootCategory?.subCategory?.get(l1)?.subCategory?.get(l2)?.subCategory?.get(l3)?.productList.push(value.cprcode);
    //                 }
    //             }
    //         }
    //         return;
    //     })
    // }

    // inspectCategory(): void {
    //     console.log(`L1 category size: ${this.rootCategory?.subCategory?.size}`);
    //     this.rootCategory?.subCategory?.forEach((l1Category: Category) => {
    //         console.log(
    //             `${l1Category.groupName} has ${l1Category.productList.length} items`);
    //         l1Category?.subCategory?.forEach((l2Category: Category) => {
    //             console.log(
    //                 `  |- ${l2Category.groupName} has ${l2Category.productList.length} items`);
    //             l2Category?.subCategory?.forEach((l3Category: Category) => {
    //                 console.log(
    //                     `     |- ${l3Category.groupName} has ${l3Category.productList.length} items`);
    //             });
    //         });
    //     });
    // }

    // async getRecommendCategory(): Promise<void> {
    //     await this.getRecommendCategoryGroup();
    //     console.log("getRecommendCategory...");
    //     this.computeRecommendCategory();
    //     // this.recommendCategory.refresh();
    //     console.log("getRecommendCategory done.");
    // }

    // async getRecommendCategoryGroup(): Promise<void> {
    //     this.recommendGroup = await this.groupRepository.getGroupRecursion("7000000000", true);
    // }

    // async getAdditionalCategoryGroup(): Promise<void> {
    //     this.additionalCategory =
    //         await this.groupRepository.getGroupRecursion("0", true);
    //     // console.log('getAdditionalCategoryGroup executed in ${stopwatch.elapsed}');
    // }

    // mergeCategory(): void {
    //     this.additionalCategory?.subGroup?.forEach((group, i) => {
    //         let replaced = false;
    //         this.rootCategory?.subCategory?.forEach((cat, j) => {
    //             if (group.groupName == cat.groupName) {
    //                 // print(
    //                 // "replace recursive from group ${group.groupId} ${group.groupName} to category ${cat.groupName}");
    //                 this.rootCategory?.subCategory?.set(j, new Category({ groupName: cat.groupName, productList: [] }))
    //                 group.productList.forEach((product) => {
    //                     if (product !== null) {
    //                         if (product.cprcode !== null) {
    //                             this.rootCategory?.subCategory?.get(j)?.productList.push(product.cprcode);
    //                             if (group.metadata.badgeLeft !== null) {
    //                                 const p = this.productMap?.get(product.cprcode)
    //                                 if (p) {
    //                                     p.badgeLeft = group.metadata.badgeLeft
    //                                 }
    //                             }
    //                             if (product.twofor !== null) {
    //                                 const p = this.productMap?.get(product.cprcode)
    //                                 if (p) {
    //                                     p.twofor = parseFloat(product.twofor)
    //                                 }
    //                             }
    //                         }
    //                     }
    //                 })
    //                 group.subGroup?.forEach((subgroup) => {
    //                     this.rootCategory?.subCategory?.get(j)?.subCategory?.set(subgroup.groupName,
    //                         new Category({
    //                             groupName: subgroup.groupName,
    //                             productList: [],
    //                             metadata: new Metadata({ show: subgroup.metadata.show })
    //                         })
    //                     )
    //                     subgroup.productList.forEach((product) => {
    //                         if (product !== null) {
    //                             if (product.cprcode !== null) {
    //                                 this.rootCategory?.subCategory?.get(j)?.subCategory?.get(subgroup.groupName)?.
    //                                     productList.push(product.cprcode);
    //                                 if (subgroup.metadata.badgeLeft !== null) {
    //                                     const p = this.productMap?.get(product.cprcode)
    //                                     if (p) {
    //                                         p.badgeLeft = subgroup.metadata.badgeLeft;
    //                                     }
    //                                 }

    //                                 if (product["twofor"] !== null) {
    //                                     const p = this.productMap?.get(product.cprcode)
    //                                     if (p) {
    //                                         p.twofor = parseFloat(product["twofor"]);
    //                                     }
    //                                 }
    //                             }
    //                         }
    //                     })
    //                     subgroup.subGroup?.forEach((subsubgroup) => {
    //                         this.rootCategory?.subCategory?.get(j)?.subCategory?.get(subgroup.groupName)?.subCategory?.set(subsubgroup.groupName,
    //                             new Category({
    //                                 groupName: subsubgroup.groupName,
    //                                 productList: [],
    //                                 metadata: new Metadata({ show: subsubgroup.metadata.show })
    //                             })
    //                         )
    //                         let preorder: PreOrder

    //                         if (subsubgroup.metadata.preType != null) {
    //                             preorder = new PreOrder({
    //                                 startDate: subsubgroup.metadata.startDate,
    //                                 endDate: subsubgroup.metadata.endDate,
    //                                 preType: subsubgroup.metadata.preType,
    //                                 preQtyPerDay: subsubgroup.metadata.preQtyPerDay,
    //                                 preRelativeDay: subsubgroup.metadata.preRelativeDay,
    //                                 deliveryDate: subsubgroup.metadata.deliveryDate,
    //                             });
    //                         }

    //                         subsubgroup.productList.forEach((product) => {
    //                             if (product !== null) {
    //                                 if (product["cprcode"] !== null) {
    //                                     this.rootCategory?.subCategory?.get(j)?.subCategory?.get(subgroup.groupName)?.
    //                                         subCategory?.get(subsubgroup.groupName)?.productList.push(product["cprcode"] as number);

    //                                     if (subsubgroup.metadata.badgeLeft != null) {
    //                                         const p = this.productMap?.get(product.cprcode)
    //                                         if (p) {
    //                                             p.badgeLeft = subsubgroup.metadata.badgeLeft;
    //                                         }
    //                                     }

    //                                     if (preorder != null) {
    //                                         const p = this.productMap?.get(product.cprcode)
    //                                         if (p) {
    //                                             p.preOrder = preorder;
    //                                         }
    //                                     }

    //                                     if (product["twofor"] != null) {
    //                                         (this.productMap?.get(product.cprcode) as IProduct).twofor =
    //                                             parseFloat(product["twofor"]);
    //                                     }
    //                                 }
    //                             }
    //                         });
    //                     });
    //                     replaced = true;
    //                 })
    //             }
    //         })
    //         if (!replaced) {
    //             this.rootCategory?.subCategory?.
    //                 set(group.groupName, new Category({
    //                     groupName: group.groupName,
    //                     productList: [],
    //                     metadata: new Metadata({ show: group.metadata.show })
    //                 }))
    //             group.productList.forEach((product) => {
    //                 if (product !== null) {
    //                     if (product["cprcode"] != null) {
    //                         this.rootCategory?.subCategory?.get(group.groupName)?.productList.push(product["cprcode"] as number);

    //                         if (group.metadata.badgeLeft != null) {
    //                             (this.productMap?.get(product.cprcode) as IProduct).badgeLeft =
    //                                 group.metadata.badgeLeft;
    //                         }

    //                         if (product["twofor"] != null) {
    //                             (this.productMap?.get(product.cprcode) as IProduct).twofor =
    //                                 parseFloat(product["twofor"]);
    //                         }
    //                     }
    //                 }
    //             });
    //             //
    //             group.subGroup?.forEach((subgroup) => {
    //                 this.rootCategory?.subCategory?.get(group.groupName)?.subCategory?.
    //                     set(subgroup.groupName, new Category({
    //                         groupName: subgroup.groupName,
    //                         productList: [],
    //                         metadata: new Metadata({ show: subgroup.metadata.show })
    //                     })
    //                     )
    //                 subgroup.productList.forEach((product) => {
    //                     if (product !== null) {
    //                         if (product["cprcode"] !== null) {
    //                             this.rootCategory?.subCategory?.get(group.groupName)?.subCategory?.get(subgroup.groupName)?.productList.push(product["cprcode"] as number)

    //                             if (subgroup.metadata.badgeLeft != null) {
    //                                 (this.productMap?.get(product.cprcode) as IProduct).badgeLeft =
    //                                     subgroup.metadata.badgeLeft;
    //                             }

    //                             if (product["twofor"] != null) {
    //                                 (this.productMap?.get(product.cprcode) as IProduct).twofor =
    //                                     parseFloat(product["twofor"]);
    //                             }
    //                         }
    //                     }
    //                 });

    //                 subgroup.subGroup?.forEach((subsubgroup) => {
    //                     this.rootCategory?.subCategory?.
    //                         get(group.groupName)?.subCategory?.
    //                         get(subgroup.groupName)?.subCategory?.
    //                         set(subsubgroup.groupName, new Category({
    //                             groupName: subsubgroup.groupName,
    //                             productList: [],
    //                             metadata: new Metadata({ show: subsubgroup.metadata.show })
    //                         }))

    //                     let preorder: PreOrder;
    //                     if (subsubgroup.metadata.preType != null) {
    //                         preorder = new PreOrder({
    //                             startDate: subsubgroup.metadata.startDate,
    //                             endDate: subsubgroup.metadata.endDate,
    //                             preType: subsubgroup.metadata.preType,
    //                             preQtyPerDay: subsubgroup.metadata.preQtyPerDay,
    //                             preRelativeDay: subsubgroup.metadata.preRelativeDay,
    //                             deliveryDate: subsubgroup.metadata.deliveryDate,
    //                         });
    //                     }

    //                     subsubgroup.productList.forEach((product) => {
    //                         if (product != null) {
    //                             if (product["cprcode"] != null) {
    //                                 this.rootCategory?.subCategory?.
    //                                     get(group.groupName)?.subCategory?.
    //                                     get(subgroup.groupName)?.subCategory?.
    //                                     get(subsubgroup.groupName)?.productList.
    //                                     push(product["cprcode"] as number);

    //                                 if (subsubgroup.metadata.badgeLeft != null) {
    //                                     (this.productMap?.get(product.cprcode) as IProduct).badgeLeft =
    //                                         subsubgroup.metadata.badgeLeft;
    //                                 }

    //                                 if (preorder != null) {
    //                                     (this.productMap?.get(product.cprcode) as IProduct).preOrder =
    //                                         preorder;
    //                                 }

    //                                 if (product["twofor"] != null) {
    //                                     (this.productMap?.get(product.cprcode) as IProduct).twofor =
    //                                         product["twofor"]?.toDouble();
    //                                 }
    //                             }
    //                         }
    //                     });
    //                 });
    //             });
    //         }
    //     })
    // }

    // computeRecommendCategory(): void {
    //     this.recommendGroup?.subGroup?.forEach((group, i) => {
    //         let replaced = false;
    //         this.recommendCategory?.subCategory?.forEach((cat, j) => {
    //             if (group.groupName == cat.groupName) {
    //                 // print(
    //                 // "replace recursive from group ${group.groupId} ${group.groupName} to category ${cat.groupName}");
    //                 this.recommendCategory?.subCategory?.set(j, new Category({ groupName: cat.groupName, productList: [] }))
    //                 group.productList.forEach((product) => {
    //                     if (product !== null) {
    //                         if (product.cprcode !== null) {
    //                             this.recommendCategory?.subCategory?.get(j)?.productList.push(product.cprcode);
    //                             if (group.metadata.badgeLeft !== null) {
    //                                 (this.productMap?.get(product.cprcode) as IProduct).badgeLeft = group.metadata.badgeLeft
    //                             }
    //                             if (product.twofor !== null) {
    //                                 (this.productMap?.get(product.cprcode) as IProduct).twofor = parseFloat(product.twofor)
    //                             }
    //                         }
    //                     }
    //                 })
    //                 group.subGroup?.forEach((subgroup) => {
    //                     this.recommendCategory?.subCategory?.get(j)?.subCategory?.set(subgroup.groupName,
    //                         new Category({
    //                             groupName: subgroup.groupName,
    //                             productList: [],
    //                         })
    //                     )
    //                     subgroup.productList.forEach((product) => {
    //                         if (product !== null) {
    //                             if (product.cprcode !== null) {
    //                                 this.recommendCategory?.subCategory?.get(j)?.subCategory?.get(subgroup.groupName)?.
    //                                     productList.push(product.cprcode);
    //                             }
    //                         }
    //                     })
    //                     subgroup.subGroup?.forEach((subsubgroup) => {
    //                         this.recommendCategory?.subCategory?.get(j)?.subCategory?.get(subgroup.groupName)?.subCategory?.set(subsubgroup.groupName,
    //                             new Category({
    //                                 groupName: subsubgroup.groupName,
    //                                 productList: [],
    //                             })
    //                         )

    //                         subsubgroup.productList.forEach((product) => {
    //                             if (product !== null) {
    //                                 if (product["cprcode"] !== null) {
    //                                     this.recommendCategory?.subCategory?.get(j)?.subCategory?.get(subgroup.groupName)?.
    //                                         subCategory?.get(subsubgroup.groupName)?.productList.push(product["cprcode"] as number);
    //                                 }
    //                             }
    //                         });
    //                     });
    //                     replaced = true;
    //                 })
    //             }
    //         })
    //         if (!replaced) {
    //             this.recommendCategory?.subCategory?.
    //                 set(group.groupName, new Category({
    //                     groupName: group.groupName,
    //                     productList: [],
    //                 }))
    //             group.productList.forEach((product) => {
    //                 if (product !== null) {
    //                     if (product["cprcode"] != null) {
    //                         this.recommendCategory?.productList.push(product["cprcode"] as number);
    //                         this.recommendCategory?.subCategory?.get(group.groupName)?.productList.push(product["cprcode"] as number);
    //                     }
    //                 }
    //             });
    //             //
    //             group.subGroup?.forEach((subgroup) => {
    //                 this.recommendCategory?.subCategory?.get(group.groupName)?.subCategory?.
    //                     set(subgroup.groupName, new Category({
    //                         groupName: subgroup.groupName,
    //                         productList: [],
    //                     })
    //                     )
    //                 subgroup.productList.forEach((product) => {
    //                     if (product !== null) {
    //                         if (product["cprcode"] !== null) {
    //                             this.recommendCategory?.subCategory?.get(group.groupName)?.subCategory?.get(subgroup.groupName)?.productList.push(product["cprcode"] as number)
    //                         }
    //                     }
    //                 });

    //                 subgroup.subGroup?.forEach((subsubgroup) => {
    //                     this.recommendCategory?.subCategory?.
    //                         get(group.groupName)?.subCategory?.
    //                         get(subgroup.groupName)?.subCategory?.
    //                         set(subsubgroup.groupName, new Category({
    //                             groupName: subsubgroup.groupName,
    //                             productList: [],
    //                         }))


    //                     subsubgroup.productList.forEach((product) => {
    //                         if (product != null) {
    //                             if (product["cprcode"] != null) {
    //                                 this.recommendCategory?.subCategory?.
    //                                     get(group.groupName)?.subCategory?.
    //                                     get(subgroup.groupName)?.subCategory?.
    //                                     get(subsubgroup.groupName)?.productList.
    //                                     push(product["cprcode"] as number);

    //                             }
    //                         }
    //                     });
    //                 });
    //             });
    //         }
    //     })
    // }
}
